<template>
  <v-container pa-2>
    <v-layout>
      <v-flex xs4>
        <p class="font-weight-bold">
          {{ item.article.productDescription }}
        </p>
      </v-flex>
    </v-layout>
    <div class="grid-container">
      <div class="grid-label">{{ $t('pricing.attributes.vatRate') }}:</div>
      <div class="grid-value">
        {{ formatNumber({ number: item.attributes.vatRate, format: numberFormats.percent }) }}
      </div>

      <div class="grid-label">{{ $t('pricing.attributes.distribution') }}:</div>
      <div class="grid-value">
        {{ formatNumber({ number: item.attributes.distribution, format: numberFormats.integer }) }}
      </div>

      <div class="grid-label">{{ $t('pricing.attributes.yearlyVolume') }}:</div>
      <div class="grid-value">
        {{ formatAbbreviatedNumber(item.yearlyVolume) }}
      </div>

      <div class="grid-label">{{ $t('pricing.attributes.yearlySales') }}:</div>
      <div class="grid-value">
        {{ formatAbbreviatedNumber(item.yearlySales) }}
      </div>

      <div class="grid-label">{{ $t('pricing.attributes.contentValue') }}:</div>
      <div class="grid-value">
        {{ formatWeight(item.attributes.contentValue, item.attributes.contentUnitOfMeasure) }}
      </div>

      <feature-toggle :toggle="includeNormWeight">
        <div class="grid-label">{{ $t('pricing.attributes.normWeight') }}:</div>
        <div class="grid-value">{{ normWeight }}</div>
      </feature-toggle>

      <div class="grid-label">{{ $t('pricing.attributes.packageType') }}:</div>
      <div class="grid-value">{{ item.attributes.packageTypeDescription }}</div>
    </div>
  </v-container>
</template>

<script>
import { get } from 'lodash';
import { includeNormWeight } from '@enums/feature-flags';
import numberFormats from '@enums/number-formats';
import numeral from 'numeral';

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      includeNormWeight,
      numberFormats,
    };
  },
  computed: {
    normWeight() {
      const normWeight = get(this.item.attributes, 'normWeight');
      const normWeightUoM = get(this.item.attributes, 'normWeightUnitOfMeasure');
      return normWeight ? this.formatWeight(normWeight, normWeightUoM) : '-';
    },
  },
  methods: {
    numeral,
    formatWeight(value, unitOfMeasurement) {
      return `${this.formatNumber({
        number: value,
        format: numberFormats.weight,
      })} ${unitOfMeasurement}`;
    },
    formatAbbreviatedNumber(value) {
      if (value == null) return '-'; // Handle null or undefined values
      // abbreviationFormat specifies the number format for abbreviations (e.g., 1.234k, 1.234m for "0.000a").
      // The dot is used as the decimal separator and remains unchanged regardless of the locale.
      return numeral(value).format(this.$t('number.abbreviationFormat'));
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: auto 1fr; /* Labels take auto width, values take remaining space */
  gap: 0.5rem 1rem;
  align-items: center;
}

.grid-label,
.grid-value {
  text-align: left;
}

p.mb-2 {
  min-height: 1em;
}
</style>
